
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Link } from 'office-ui-fabric-react/lib/Link';

import Text from '../../common/client/components/Text';

import { getProject, getProjectKatuzeItems } from '../../reducers/project';
import projectGetActions from '../../sagas/project';

import DialogConfirm from '../common/DialogConfirm';
import IfComp from '../common/IfComp';

const classNames = mergeStyleSets({
    title: {
    },
    tools: {
    }
});

const KatuzeItem = (props) => {

    const dispatch = useDispatch();
    const projectActions = projectGetActions(dispatch);

    const token = useSelector(state => {
        return state.auth.data ? state.auth.data.user.token : null;
    });

    const project = useSelector(state => getProject(state.project));
    const projectKatuzeItems = useSelector(state => getProjectKatuzeItems(state.project));

    const handleDeleteClick = async () => {
        const message = `Opravdu chcete smazat katastrální území "${props.item.nazev}"?`;

        let confirm = await DialogConfirm.show(message);
        if (confirm) {
            projectActions.setParameter(
                token, project.id, 'katuzeItems',
                JSON.stringify(
                    projectKatuzeItems.filter(item => item.kod !== props.item.kod)
                )
            );
        }
    }

    return (
        <Stack horizontal tokens={{childrenGap: 8}}>
            <Stack.Item className={classNames.title}>
                {props.item.nazev}
            </Stack.Item>
            <Stack.Item grow className={classNames.title}>
                ({props.item.kod})
            </Stack.Item>
            <Stack.Item className={classNames.tools}>
                <Stack horizontal tokens={{childrenGap: 4}}>
                    <IfComp cond={!props.readOnly}>
                        <Link onClick={handleDeleteClick} title="Smazat katastrální území">Smazat</Link>
                    </IfComp>
                </Stack>
            </Stack.Item>
        </Stack>
    );
}

const KatuzeItems = (props) => {
    return (
        <Stack tokens={{childrenGap: 4}}>
            {(props.katuzeItems && props.katuzeItems.length > 0)
                ? props.katuzeItems.map(item => {
                    return (
                        <KatuzeItem
                            key={item.kod}
                            item={item}
                            readOnly={props.readOnly}
                        />
                    );
                })
                : <Text>Seznam katastrálních území je prázdný.</Text>
            }
        </Stack>
    );
}

export default KatuzeItems;
